<script setup>
import FormCategoryVisibilityForm from "@/components/helpdesk/assignment_rules/FormCategoryVisibilityForm.vue";
import FormCategoryForm from "@/components/helpdesk/assignment_rules/FormCategoryForm.vue";
import FormCategoryDataTable from "@/components/helpdesk/assignment_rules/FormCategoryDataTable.vue";
import { useNavigationStore } from "@/stores/navigation"
import { onMounted, ref, watch } from "vue";
import axios from "@/utils/axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useLoading } from "vue-loading-overlay";
import loaderData from "@/utils/loader-data";
import DeleteConfirm from "@/components/common/DeleteConfirm.vue";

const $loading = useLoading(loaderData);
const navigationStore = useNavigationStore()
const errors = ref([]);
const headers = ref([
  {
    title: "Name",
    key: "name",
    sortable: true,
  },
  {
    title: "Status",
    key: "status",
    sortable: true,
  },
  {
    title: "Actions",
    key: "actions",
    sortable: false,
  },
]);

const form_categories = ref([]);
const openModal = ref(false);
const openPermissionModal = ref(false);
const deleteDialog = ref(false);
const isCanSeeCreateBtn = ref(false);
const modeModal = ref("create");

const filterInfo = ref({});
const editedItem = ref({});

const getFormCategories = async (payload = null) => {
  let url = `/helpdesk/form-categories?page=${payload.page}&per_page=${payload.perPage}`;
  if (payload.searchQuery && payload.searchQuery.trim() !== "") {
    url += `&search_query=${encodeURIComponent(payload.searchQuery.trim())}`;
  }
  let loader = $loading.show();
  axios
    .get(url)
    .then((response) => {
      if (response.status == "success") {
        form_categories.value = response.data;
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        toast.error(response.message, {
          autoClose: 2000,
        });
      }
    })
    .catch((error) => {
      loader.hide();
    })
    .finally(() => {
      loader.hide();
    });
};


const canSeeCreateBtn = async () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userPermissionsByRoles = userData.permissions_by_roles;
  isCanSeeCreateBtn.value = Object.values(userPermissionsByRoles).some(
    (permissions) => permissions.includes("Create Assignment Rule")
  );
};

const openCreateModel = async () => {
  modeModal.value = "create";
  editedItem.value = {};
  openModal.value = true;
};

// Page changed from pagination
const tableChanged = async (payload) => {
  filterInfo.value = { ...filterInfo.value, ...payload };
  getFormCategories(filterInfo.value);
};

const searchValue = async (payload) => {
  filterInfo.value.searchQuery = payload;
  getFormCategories(filterInfo.value);
};

const refreshFormCategories = async () => {
  getFormCategories(filterInfo.value);
};

const editItem = (item) => {  
  editedItem.value = item;
  modeModal.value = "Update";
  openModal.value = true;
};

const assignPermissions = (item) => {
  editedItem.value = item;
  modeModal.value = "assign";
  openPermissionModal.value = true;
};

const deleteItem = (item) => {
  editedItem.value.id = item.id;
  deleteDialog.value = true;
};

const deleteItemConfirm = async () => {
  axios
    .delete("/helpdesk/form-categories/" + `${editedItem.value.id}`)
    .then((response) => {
      if (response.status == "success") {
        toast.success(response.message, {
          autoClose: 2000,
        });
        deleteDialog.value = false;
        // refresh the users list via API
        getFormCategories(filterInfo.value);
      } else {
        toast.error(response.message, {
          autoClose: 2000,
        });
      }
    })
    .catch((error) => {})
    .finally(() => {});
};

// load contacts when page loads
onMounted(async () => {
  navigationStore.setRouteActiveName("helpdesk-forms")
  console.log('navigationStore', navigationStore);

  canSeeCreateBtn();
});

// expose errors and getContacts
defineExpose({
  errors,
  getFormCategories,
});

definePage({ meta: { requiresAuth: true } });
</script>

<template>
  <VCard title="" class="">
    <VCardText class="p-0" style="padding: 0 !important">
      <FormCategoryDataTable
        :headers="headers"
        :table-data="form_categories"
        :canSeeCreateBtn="isCanSeeCreateBtn"
        @tableChanged="tableChanged"
        @searchValue="searchValue"
        @isDialogVisible="openCreateModel"
        @editItem="editItem"
        @deleteItem="deleteItem"
        @itemVisibility="assignPermissions"
      />
    </VCardText>
  </VCard>

  <FormCategoryForm
    v-model:isDialogVisible="openModal"
    :form-data="editedItem"
    :mode="modeModal"
    @refreshFormCategories="refreshFormCategories"
  />
  <FormCategoryVisibilityForm
    v-model:isDialogVisible="openPermissionModal"
    :form-data="editedItem"
    :mode="modeModal"
    @refreshFormCategories="refreshFormCategories"
  />

  <DeleteConfirm
    v-model:deleteDialog="deleteDialog"
    @closeDelete="deleteDialog = false"
    @deleteItemConfirm="deleteItemConfirm"
  />
</template>
